import styled from 'styled-components';

import { Button } from '@/core/components/Button';

import {
  breakpoint,
  sizes,
} from '@/themes/breakpoints';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 40px;
  gap: 8px;

  @media ${breakpoint.sm} {
    grid-template-columns: repeat(3, 1fr);
    margin-bottom: 60px;
    gap: 22px;
  }

  @media ${breakpoint.md} {
    grid-template-columns: repeat(5, 1fr);
    margin-bottom: 80px;
    gap: clamp(
      21px,
      (100vw - ${sizes.tablet.minWidth}px) / ${sizes.desktopLarge.minWidth},
      24px
    );
  }
`;

export const ViewMoreButton = styled(Button)`
  width: 100%;
  height: 100%;
  cursor: pointer;
`;
